import React from "react";

import "./homestyle.css";
import SideBar1 from "../chats/sidebar1";
import HomeHeader1 from "../../components/HomeHeader1";
import OuterInnerPage from "./OuterInnerPage";

const OuterPage = (
    {
    fromTFT,
    loaderText,
      allMessage,
    message,
    setMessage,
    handleSend,
    BotTyping,
    visibleMsgBox,
    editingIndex,
    editedMessage,
    setEditedMessage,
    handleEditClick,
    handleSaveClick,
    setEditingIndex,
    initializeChat,
     chatLoading,
      highLightBtn,
    handleBottom,
    AllbuttomMessage,
    showEmptyStateForId,
    emptyStateId,
    planDocReady,
    planDocMeta,
    finalPlanMessageIndex,
    isStreamingResponse,
    onDownloadPlan,
    onSaveToGoogleDocs,
    onOpenPlanDoc,
    googleSaving,
    googleDriveConnected,
    googleDriveEmail,
  }

) => {
  

  

  // Toggle Sidebar Function
  // const toggleSidebar = (forceOpen?: boolean) => {
  //   let sidebar = document.getElementById("sidebar");
  //   let content = document.getElementById("content");
  //   let header = document.getElementById("header");

  //   if (forceOpen) {
  //     sidebar?.classList.add("open");  // ✅ Force Open Sidebar
  //     content?.classList.add("shrink");
  //     header?.classList.add("shrink");
  //   } else {
  //     sidebar?.classList.toggle("open");
  //     content?.classList.toggle("shrink");
  //     header?.classList.toggle("shrink");
  //   }
  // };


  return (
    <>
     <div className="sidebar-content-other afterchatbot-layout">
      <SideBar1/>
        <div className="home-page-content-inner">
        <HomeHeader1/>
         <OuterInnerPage
                   fromTFT={fromTFT}
                   loaderText={loaderText}
                   allMessage={allMessage}
                   message={message}
                   setMessage={setMessage}
                   BotTyping={BotTyping}
                   handleSend={handleSend}
                   visibleMsgBox={visibleMsgBox}
                   editingIndex={editingIndex}
                   editedMessage={editedMessage}
                   setEditedMessage={setEditedMessage}
                   handleEditClick={handleEditClick}
                   handleSaveClick={handleSaveClick}
                   setEditingIndex={setEditingIndex}
                   initializeChat ={initializeChat}
                   chatLoading={chatLoading}
                    highLightBtn={highLightBtn}
                    handleBottom={handleBottom}
                    AllbuttomMessage={AllbuttomMessage}
                   showEmptyStateForId={showEmptyStateForId}
                   emptyStateId={emptyStateId}
                   planDocReady={planDocReady}
                   planDocMeta={planDocMeta}
                   finalPlanMessageIndex={finalPlanMessageIndex}
                   isStreamingResponse={isStreamingResponse}
                   onDownloadPlan={onDownloadPlan}
                   onSaveToGoogleDocs={onSaveToGoogleDocs}
                   onOpenPlanDoc={onOpenPlanDoc}
                   googleSaving={googleSaving}
                   googleDriveConnected={googleDriveConnected}
                   googleDriveEmail={googleDriveEmail}
         />
        </div>
      </div>
  
    </>
  );
};

export default OuterPage;
